<!--
    @Author : Luo
    @Time   : 2020/8/12 11:32
-->
<template>
  <div class="page_video_overview">
    <div class="page_video_nav">
      <div class="page_video_stage flex_center">
        <div v-for="(item, i) in stageDate" :key="i"
             :data-id="item.id" @click="setStage(item.id)"
             :class="'page_video_stage_container ' + (item.id === stageCurrent ? 'page_video_stage_active' : '')">
          <span>{{ item.val }}</span>
        </div>
      </div>
      <div class="page_video_class flex_center">
        <div class="no_user_hint" v-if="stageVideoDate.length <= 0"><span>{{ noVideoHint }}</span></div>
        <div v-for="(item, i) in stageVideoDate" :key="i"
             :data-id="item.id" @click="setStageVideo(item.id)"
             :class="'page_video_class_container flex_center ' + (item.id === stageVideoCurrent ? 'page_video_class_active' : '')">
          <div class="page_video_class_label"><span>{{ item.name }}</span></div>
          <div class="page_video_class_content flex_center">
            <div class="page_video_class_watch flex_center">
              <div class="page_video_class_watch_content"><span>{{ item.watch ? item.watch : 0 }}</span></div>
              <div class="page_video_class_watch_label"><span>播放量</span></div>
            </div>
            <div class="page_video_class_down flex_center">
              <div class="page_video_class_watch_content"><span>{{ item.down ? item.down : 0 }}</span></div>
              <div class="page_video_class_watch_label"><span>下载量</span></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="page_video_main" v-if="stageVideoDate.length > 0">
      <div class="page_video_main_nav flex_center">
        <div @click="setAccountNav('reg')"
             :class="'account_video_stage_container ' + (accountNavStatus === 'reg' ? 'account_video_stage_active' : '')">
          <span>注册账号</span>
        </div>
        <div v-if="this.accountClientDate['class' + stageVideoCurrent] && this.accountClientDate['class' + stageVideoCurrent]['vis'] && accountClientDate['class' + stageVideoCurrent]['vis'].length > 0"
             @click="setAccountNav('vis')"
             :class="'account_video_stage_container ' + (accountNavStatus === 'vis' ? 'account_video_stage_active' : '')">
          <span>游客</span>
        </div>
      </div>
      <div class="account_page_main text_left">
        <div class="account_page_main_header flex_center">
          <div class="account_page_main_client"><span>用户</span></div>
          <div class="account_page_main_page"><span>观看进度</span></div>
          <div class="account_page_main_time"><span>观看时长</span></div>
        </div>
        <div class="account_page_main_list flex_center">
          <div class="no_user_hint text_center" v-if="JSON.stringify(tempClientDate).length <= 2"><span>{{ noDataHint }}</span></div>
          <div class="account_page_main_client_container flex_center" v-for="(item, i) in tempClientDate['current' + pagination.current]" :key="i">
            <div class="account_page_main_client_info flex_center">
              <div class="account_page_main_client_info_container flex_center" v-if="item.firstname && item.firstname.length > 0">
                <div class="account_page_main_client_info_label"><span>用户名</span></div>
                <div class="account_page_main_client_info_text"><span>{{ item.firstname }}</span></div>
              </div>
              <div class="flex_center account_page_main_client_info_main">
                <div class="account_page_main_client_info_container flex_center" v-if="item.userName && item.userName.length > 0">
                  <div class="account_page_main_client_info_label"><span>帐号</span></div>
                  <div class="account_page_main_client_info_text"><span>{{ item.userName }}</span><span v-if="item.register" class="user_identification">游客注册</span></div>
                </div>
                <div class="account_page_main_client_info_container flex_center" v-if="item.nickname && item.nickname.length > 0">
                  <div class="account_page_main_client_info_label"><span>微信名</span></div>
                  <div class="account_page_main_client_info_text"><span>{{ item.nickname }}</span></div>
                </div>
              </div>
            </div>
            <div class="account_page_main_page flex_center">
              <div class="progress_bg text_left">
              <span :class="(0 <= resetSpecNum(item.playProgress) && resetSpecNum(item.playProgress) <= 35) ?
                'progress_red' : (35 < resetSpecNum(item.playProgress) && resetSpecNum(item.playProgress) <= 70 ?
                'progress_blue' : 'progress_green')"
                    :style="'width: ' + resetSpecNum(item.playProgress) + '%'"></span>
              </div>
              <span style="margin-left: 15px">{{ resetSpecNum(item.playProgress) + '%' }}</span>
            </div>
            <div class="account_page_main_time"><span>{{ setTimeType(item.playTotalTime) }}</span></div>
          </div>
        </div>
      </div>
      <div>
        <pagination :key="pagination.length" :default-current="pagination.current" :length="pagination.length" :default-amount="pagination.amount" v-on:pageCurrent="pageCurrent" />
      </div>
    </div>
  </div>
</template>

<script>
import pagination from '@/components/pagination/index'
import { _Ajax, initLogin, logout } from '@/api/_axios'
import { newMap, setTimeType, resetSpecNum } from '@/components/common/common_js'

export default {
  name: 'accountAnalysisPage',
  components: {
    pagination
  },
  data () {
    return {
      title: '',
      setTimeType: setTimeType,
      resetSpecNum: resetSpecNum,
      stageDate: [], // 阶段数据
      stageCurrent: 'one', // 阶段下标
      stageVideoDate: [], // 课程的每一节
      accountNavStatus: 'reg', // 注册账号或者游客的状态
      accountClientDate: {}, // 注册账号或者游客下的客户数据
      stageVideoCurrent: 0, // 记录当前课程的id
      tempClientDate: {}, // 页面显示的客户数据
      noDataHint: '', // 没有客户数据
      noVideoHint: '', // 没有视频数据
      pagination: {
        length: 0,
        amount: 10,
        current: 1
      }
    }
  },
  methods: {
    // 阶段切换
    setStage: function (v) {
      this.stageCurrent = v
      this.stageVideoCurrent = 0
      this.getStageDate()
    },
    // 课程切换
    setStageVideo: function (v) {
      let that = this
      that.stageVideoCurrent = v
      // 每次切换课程替换客户状态为注册
      that.accountNavStatus = 'reg'
      that.pagination.current = 1
      if (that.accountClientDate['class' + that.stageVideoCurrent]['reg']) {
        that.pagination.length = that.accountClientDate['class' + that.stageVideoCurrent]['reg'].length
        that.setUserDate(that.accountClientDate['class' + that.stageVideoCurrent]['reg'])
      } else {
        that.pagination.length = 0
        that.setUserDate([])
      }
      if (that.pagination.length <= 0) {
        that.noDataHint = '暂无客户数据'
      }
    },
    // 设置客户的数据 arr: 数组, amount: 条目
    setUserDate: function (arr) {
      if (arr.length < 0) {
        this.tempClientDate = {}
        return
      }
      let tempArr = []
      let amount = this.pagination.amount
      let tempAmount = Math.ceil(this.pagination.length / amount)
      this.tempClientDate = {}
      for (let i = 1; i <= tempAmount; i++) {
        newMap(arr, (e, j) => {
          if (amount * ((i - 1) <= 0 ? 0 : i - 1) <= j && amount * i > j) {
            tempArr.push(e)
          }
        })
        this.tempClientDate['current' + i] = tempArr
        tempArr = []
      }
    },
    pageCurrent: function (data) {
      this.pagination.current = data.current
      // 选择每页显示条数的时候在刷新列表、条目及组件
      if (data.event === 'amount') {
        this.pagination.amount = data.amount
        this.setUserDate(this.accountClientDate['class' + this.stageVideoCurrent][this.accountNavStatus])
      }
    },
    // 注册账号/游客 切换
    setAccountNav: function (v) {
      this.accountNavStatus = v
      if (this.accountClientDate && this.accountClientDate['class' + this.stageVideoCurrent] && this.accountClientDate['class' + this.stageVideoCurrent][v]) {
        this.pagination.length = this.accountClientDate['class' + this.stageVideoCurrent][v].length
        this.setUserDate(this.accountClientDate['class' + this.stageVideoCurrent][v])
      }
    },
    // 获取阶段的数据
    getStageDate: function () {
      let that = this

      that.clearUserData()

      _Ajax(
        {
          method: 'get',
          url: '/data/overview_video/level/' + that.stageCurrent,
          clearCancelSource: true
        },
        (res) => {
          if (res.status === 401) {
            setTimeout(() => {
              that.$notice({type: 'error', content: '视频概览：认证令牌错误！'})
              logout(that.$router)
            }, 0)
          } else if (res.status === 200) {
            res = res.data

            if (res && res.length > 0) {
              newMap(res, (e, j) => {
                // 课程
                that.stageVideoDate.push({name: e.title, watch: e.playNum, down: e.downloadNum, id: j})

                // 课程下的用户数据 ex: {'reg': [], 'vis': []}
                if (!that.accountClientDate['class' + j]) {
                  that.accountClientDate['class' + j] = {}
                }
                if (e.videoRegisterUserList && e.videoRegisterUserList.length > 0) {
                  that.accountClientDate['class' + j]['reg'] = e.videoRegisterUserList
                }
                if (e.videoVisitorUserList && e.videoVisitorUserList.length > 0) {
                  that.accountClientDate['class' + j]['vis'] = e.videoVisitorUserList
                }
              })

              if (that.accountClientDate['class' + that.stageVideoCurrent]['reg']) {
                that.pagination.length = that.accountClientDate['class' + that.stageVideoCurrent]['reg'].length
                that.setUserDate(that.accountClientDate['class' + that.stageVideoCurrent]['reg'])
              } else {
                that.pagination.length = 0
                that.setUserDate([])
              }
            } else {
              that.pagination.length = 0
              that.setUserDate([])
            }

            if (that.pagination.length <= 0) {
              that.noDataHint = '暂无客户数据'
            }
          }
        },
        (rej) => {
          console.log('error--', rej)
          that.noDataHint = '暂无客户数据'
        }
      )
    },
    // 清空用户数据
    clearUserData: function () {
      let that = this

      that.noDataHint = '数据正在加载中...'
      that.noVideoHint = '数据正在加载中...'
      that.pagination.length = 0
      that.pagination.current = 1
      that.accountClientDate = {}
      that.stageVideoDate = []
      that.setUserDate([])
    },
    // 测试接口是否有效
    getUser: function (call) {
      let that = this
      _Ajax(
        {
          method: 'get',
          url: '/api/profileManagement/home'
        },
        (res) => {
          if (res.status === 401) {
            that.$notice({type: 'error', content: '登录已失效，请重新登录！'})
            logout(that.$router)
          } else if (res.status === 200) {
            call()
          }
        },
        (rej) => { console.log('b--', rej) }
      )
    }
  },
  mounted () {},
  beforeMount: function () {
    let that = this

    let tempLogoutStatus = true
    initLogin(that.$router, () => {
      tempLogoutStatus = false
    })

    if (!tempLogoutStatus) {
      that.$notice({type: 'error', content: '登录已失效，请重新登录！'})
    } else {
      that.getUser(() => {
        // 课程的阶段
        that.stageDate = [
          {val: '阶段一', id: 'one'},
          {val: '阶段二', id: '2'},
          {val: '阶段三', id: '3'}
        ]

        that.getStageDate()
      })
    }
  }
}
</script>

<style scoped>
.page_video_stage {justify-content: flex-start}
.page_video_stage_container {cursor: pointer;width: 120px;height: 48px;background: rgba(255, 255, 255, 1);border-radius: 24px}
.page_video_stage_container:not(:first-of-type) {margin-left: 24px}
.page_video_stage_container span {font-size: 16px;font-weight: 500;color: rgba(96, 96, 96, 1);line-height: 48px}
.page_video_stage_active, .page_video_stage_container:hover {background: rgba(76, 139, 255, 1)}
.page_video_stage_active span, .page_video_stage_container:hover span {color: rgba(255, 255, 255, 1)}

.page_video_class {justify-content: flex-start;margin-top: 30px;overflow-x: auto;padding-bottom: 10px}
.page_video_class::-webkit-scrollbar {height: 8px}
.page_video_class::-webkit-scrollbar-thumb {background: rgba(144, 144, 144, .6);border-radius: 4px}
.page_video_class::-webkit-scrollbar-track-piece {background-color: rgba(255, 255, 255, .8)}
.page_video_class_container {cursor: pointer;padding: 24px;height: 128px;flex-flow: column;align-items: flex-start;justify-content: space-between;background: rgba(255, 255, 255, 1);border-radius: 6px;border: 2px solid rgba(55, 136, 248, 0)}
.page_video_class .page_video_class_container:not(:first-of-type) {margin-left: 20px}
.page_video_class_label {min-width: 268px;white-space: nowrap;text-align: left}
.page_video_class_active, .page_video_class_container:hover {border: 2px solid rgba(55, 136, 248, 1)}
.page_video_class_label span {font-size: 24px;font-weight: 500;color: rgba(48, 48, 48, 1)}
.page_video_class_content {justify-content: space-between;align-items: flex-end}
.page_video_class_watch, .page_video_class_down {min-width: 120px;flex-flow: column;align-items: flex-start}
.page_video_class_watch_label {margin-top: 12px}
.page_video_class_watch_label span, .page_video_class_watch_content span {font-size: 28px;font-weight: 500;color: rgba(48, 48, 48, 1)}
.page_video_class_watch_label span {font-size: 16px}

.account_video_stage_container {cursor: pointer;transition: all .1s;padding-bottom: 16px;border-bottom: 1px solid rgba(76, 139, 255, 0)}
.account_video_stage_container:not(:first-of-type) {margin-left: 54px}
.account_video_stage_container span {font-size: 16px;font-weight: 500;color: rgba(96, 96, 96, 1)}
.account_video_stage_active, .account_video_stage_container:hover {border-bottom: 1px solid rgba(76, 139, 255, 1)}
.account_video_stage_active span, .account_video_stage_container:hover span {color: rgba(76, 139, 255, 1)}

.page_video_main {padding: 30px 32px;margin-top: 21px;background-color: rgba(255, 255, 255, 1);border-radius: 6px}
.page_video_main_nav {justify-content: flex-start}
.page_wait_time {justify-content: space-between}
.page_wait_time_container {justify-content: flex-start;flex-flow: column;align-items: flex-start}
.page_wait_time .page_wait_time_container:not(:first-of-type) {margin-left: 100px}
.page_wait_time_info span {font-size: 28px;font-weight: 500;color: rgba(40, 40, 40, 1)}
.page_wait_time_label {margin-top: 12px}
.page_wait_time_label span {font-size: 16px;font-weight: 500;color: rgba(48, 48, 48, 1)}

.account_page_main {margin-top: 20px}
.account_page_main_header {justify-content: flex-start;padding: 0 23px;height: 50px;background-color: rgba(248, 248, 248, 1)}
.account_page_main_header span {font-size: 14px;font-weight: 400;color: rgba(102, 102, 102, 1)}
.account_page_main_client_container {justify-content: flex-start;padding: 16px 23px 12px;width: calc(100% - 46px);height: 50px;border-bottom: 1px solid rgba(235, 235, 235, 1)}
.account_page_main_header > div:not(:first-of-type) .account_page_main_client_container > div:not(:first-of-type) {margin-left: 20px}
.account_page_main_client_container span {font-size: 14px;font-weight: 500;color: rgba(40, 40, 40, 1)}
.account_page_main_client {width: 480px;padding-right: 20px}
.account_page_main_page {width: 220px;justify-content: flex-start;padding-right: 20px}
.account_page_main_time {width: 180px;padding-right: 20px;text-align: center}
.account_page_main_list {flex-flow: column;justify-content: flex-start;align-items: flex-start}
.account_page_main_client_info {width: 480px;padding-right: 20px;justify-content: flex-start;align-items: flex-start;flex-flow: column}
.account_page_main_client_info_container {justify-content: flex-start}

.account_page_main_client_info > div:not(:first-of-type) {margin-top: 10px}
.account_page_main_client_info_main {justify-content: flex-start}
.account_page_main_client_info_container .account_page_main_client_info_text {margin-left: 10px}
.account_page_main_client_info_main > div:first-of-type .account_page_main_client_info_text {min-width: 60px}
.account_page_main_client_info_main > div:not(:first-of-type) {margin-left: 40px}
.account_page_main_client_info_label span {color: rgba(102, 102, 102, 1);font-size: 14px;font-weight: 400}
.account_page_main_client_info_text span {color: rgba(40, 40, 40, 1);font-size: 14px;font-weight: 500}

.progress_bg {width: 120px;background-color: rgba(240, 242, 245, 1);border-radius: 3px;line-height: 0}
.progress_bg span {height: 6px;border-radius: 3px;display: inline-block}
.progress_bg .progress_red {background: rgba(245, 72, 88, 1)}
.progress_bg .progress_blue {background: rgba(76, 139, 255, 1)}
.progress_bg .progress_green {background: rgba(51, 239, 130, 1)}

.user_identification {margin-left: 16px;background-color: rgba(76, 139, 255, 0.12);padding: 4px 9px;border-radius: 4px}
.account_page_main_client_container span.user_identification {color: rgba(76, 139, 255, 1);font-size: 12px;font-weight: 500}

.no_user_hint {margin: 30px 0;width: 100%}
.no_user_hint span {font-size: 16px;font-weight: 500;color: rgba(143, 143, 143, 1)}
</style>



// WEBPACK FOOTER //
// src/components/page-video/index.vue